import colors from '../../_shared/colors';

export const cardStyles = {
  container: `
    width: 100%;
    padding: 10px;
  `,
  card: `
    height: 298px;
    overflow: hidden;
  `,
  cardOutline: `
    border-color: ${colors.cardOutline};

    &:hover {
      border-color: ${colors.cardOutline};
    }
  `,
  image: `
    height: 100px;
  `,
  imageHolder: `
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-bottom: 2px solid ${colors.inputBorder};
  `,
  icon: `
    color: ${colors.success};
    position: absolute;
    top: 5px;
    left: 5px;
  `,
  iconRight: `
    left: auto;
    right: 5px;
  `,
  cardText: `
    font-size: 12px;

    p {
      margin: 0;
    }
  `,
  cardTitle: `
    font-weight: bold;
  `,
  statusContainer: `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  `,
  cardStatus: `
    float: left;
    padding: 2px 7px;
    color: ${colors.white};
    font-size: 12px;
    margin-top: 5px;
    margin-right: 5px;
  `,
  serviceOverdueText: `
    color: ${colors.error};
    margin-bottom: 0px;
  `,
  mobileCard: `
    position: relative;
    border-radius: 10px;
    overflow: hidden;

    .ant-card-body {
      padding: 10px 12px;
      /* allow card body to expand vertically when many status tags wrap */
      min-height: 100px;
      overflow: hidden;
    }
  `,
  mobileAlertStripe: `
    height: 10px;
    margin: -10px -12px 6px -12px;
  `,
  mobileIdentifier: `
    display: flex;
    flex-direction: row;
    align-items: center;
    /* reserve space for the absolute status tags column on the right.
       'Power Up Override' is the longest tag (~150px); add a small buffer. */
    margin-right: 160px;
    margin-bottom: 4px;
    min-width: 0;
  `,
  mobileIdentifierText: `
    font-weight: bold;
    font-size: 14px;
    margin: 0;
    overflow-wrap: break-word;
    word-break: break-word;
    color: ${colors.black};
    flex: 0 1 auto;
    min-width: 0;
  `,
  mobileStatusRight: `
    position: absolute;
    top: 10px;
    right: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    /* constrain width so tags wrap (stack) within the card rather than
       overflow horizontally. ~150px fits 'Power Up Override' on one line. */
    max-width: 150px;

    > div {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
      max-width: 150px;
    }

    > div > div {
      margin: 0;
      float: none;
      max-width: 100%;
      white-space: nowrap;
    }
  `,
  mobileStatusRightWithStripe: `
    /* when the major/minor alert stripe is shown the status tags need to clear
       the stripe + a small gap so they don't sit flush against the colored bar */
    top: 18px;
  `,
  mobileDetails: `
    font-size: 13px;
    line-height: 1.35;
    /* match identifier so detail text wraps before reaching status tags */
    margin-right: 160px;

    p {
      margin: 0;
    }
  `,
  mobileDetailLine: `
    overflow-wrap: break-word;
    word-break: break-word;
  `,
  mobileLabel: `
    color: ${colors.labelColor};
  `,
  mobileValue: `
    color: ${colors.black};
    font-weight: 500;
  `,
};

export default {
  container: `
    position: relative;
    height: 100%;
  `,
  cardContainer: `
    margin-top: 10px;
    padding-bottom: 30px;
  `,
  loadingContainer: `
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    width: 100%;
    padding: 40px 20px;
    box-sizing: border-box;
  `,
  noEquipHeader: `
    color: ${colors.highlight};
    font-size: 15px;
    font-weight: bold;
  `,
  noEquipText: `
    max-width: 420px;
    width: 100%;
    margin-top: 0px;
    font-size: 12px;
    text-align: center;
  `,
  serviceOverdueText: `
    color: ${colors.error};
    margin: 0;
  `,
  consignmentContainer: `
    background-color: ${colors.statusStandby};
    margin-left: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    margin-bottom: 3px; 
  `,
  consignmentContainerTable: `
    background-color: ${colors.statusStandby};
    margin-left: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    margin-bottom: 2px;
  `,
  consignmentText: `
    color: ${colors.white};
    font-weight: 600;
    font-size: 10px;
    line-height: 16px;
    margin: 0;
  `,
  mobileCountContainer: `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 12px 4px;
    font-size: 13px;
    color: ${colors.labelColor};
  `,
  locationGroup: `
    margin-bottom: 18px;
  `,
  locationGroupHeader: `
    padding: 6px 4px;
    margin-bottom: 6px;
    border-bottom: 1px solid ${colors.inputBorder};

    p {
      margin: 0;
    }
  `,
  locationGroupName: `
    font-size: 15px;
    font-weight: 600;
    color: ${colors.black};
  `,
  locationGroupAddress: `
    font-size: 12px;
    color: ${colors.labelColor};
    margin-top: 2px;
  `,
  locationEmpty: `
    font-size: 13px;
    font-style: italic;
    color: ${colors.labelColor};
    padding: 8px 4px;
    margin: 0;
  `,
};
